export const DEFAULTS = {
    EXCERPT_MAX_TEXT: 20,
};
